import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  plans: [
    {
      id: 'turf',
      title: 'Turf Weed Management',
      description: 'Selective herbicide programs that eliminate broadleaf weeds, invasive grasses, and undesirable species while preserving healthy turf on sportsfields, parks, cemeteries, school grounds, and commercial properties. Seasonal treatment schedules are customized to BC growing conditions.',
      deliverables: ['Site assessment or remote evaluation', 'Custom herbicide program', 'Seasonal treatment schedule', 'Detailed invoicing with area descriptions'],
      price: 'Request a Quote'
    },
    {
      id: 'bare-ground',
      title: 'Bare Ground Vegetation Control',
      description: 'Total vegetation elimination for industrial areas requiring zero plant growth. Pre-emergent and post-emergent herbicide programs for rail yards, substations, gravel pads, tank farms, pipeline corridors, and equipment storage areas. Season-long residual programs available.',
      deliverables: ['Site evaluation and program design', 'Season-long or contact application options', 'Detailed invoicing with area descriptions'],
      price: 'Request a Quote'
    },
    {
      id: 'noxious-weeds',
      title: 'Noxious & Invasive Weed Control',
      description: 'Targeted herbicide treatment for BC-regulated noxious and invasive species including knapweed, Canada thistle, Scotch broom, knotweed, and purple loosestrife. Programs comply with the BC Weed Control Act and support your site\'s environmental obligations.',
      deliverables: ['Weed species identification', 'Targeted treatment plan', 'Selective herbicide application', 'Compliance documentation upon request'],
      price: 'Request a Quote'
    },
  ],
};

export const plansSlice = createSlice({
  name: 'plans',
  initialState,
  reducers: {},
});

export const { } = plansSlice.actions;
export const selectPlans = (state) => state.plans.plans;
export default plansSlice.reducer;
